<template>
	<div class="add-product">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:visible.sync="dialogProduct"
			width="850px"
			top="5vh"
			custom-class="addproductclass"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<template #title>
				<div class="title_header">
					<span>
						{{
							product.id ? $t("addProduct.edit") : $t("addProduct.add")
						}}</span
					>
				</div>
			</template>
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="product"
					label-width="80px"
					:model="product">
					<!-- 基础设置 -->
					<el-row :gutter="20">
						{{ $t("product.AddProduct.976199-0") }}
					</el-row>
					<template>
						<el-row :gutter="20">
							<el-col :span="8" v-if="fromMaterial !== '1'">
								<el-form-item
									:label="$t('addProduct.productTypeId')"
									prop="typeId">
									<el-select
										v-model="product.typeId"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										filterable
										:placeholder="$t('addProduct.pProductTypeId')">
										<el-option
											v-for="item in machineType"
											:key="item.id"
											:label="item.name"
											:value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('addProduct.goodsName')" prop="name">
									<el-input
										v-model="product.name"
										:placeholder="$t('addProduct.pProductName')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('addProduct.price')" prop="costPrice">
									<el-input
										v-model="product.costPrice"
										:placeholder="$t('addProduct.pPrice')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item
									:label="$t('addProduct.image')"
									prop="url"
									style="margin-bottom: 0">
						<div class="upload-wrapper">
							<el-upload
								ref="productImageUpload"
								:action="uploadUrl"
								:headers="uploadHeaders"
								accept=".jpg,.png"
								:file-list="fileList"
								:on-error="handleImageError"
								:before-upload="beforImageUpload"
								:on-success="handleImageSuccess"
								:on-remove="handleImageRemove"
								:on-exceed="handleImageExceed"
								:limit="1"
								:show-file-list="false"
								list-type="picture-card">
								<i v-if="!product.url" class="el-icon-plus"></i>
								<div
									v-else
									class="uploaded-image">
									<img
										:src="product.url"
										alt="" />
								</div>
							</el-upload>
							<div v-if="imageUploading" class="upload-loading">
								<i class="el-icon-loading"></i>
							</div>
						</div>
									<!-- <div style="color: red;font-size: 12px;">
									尺寸建议300*300,且文件不大于1m
								</div> -->
								</el-form-item>
							</el-col>
						</el-row>
					</template>
					<el-row :gutter="20" style="margin-top: 20px; margin-bottom: 10px">
						<span>{{ $t("product.AddProduct.976199-1") }}</span>
						<template> </template>
						<el-button
							style="margin-left: 10px"
							type="primary"
							round
							size="mini"
							v-if="!isExpand"
							@click="isExpand = true"
							>{{ $t("product.AddProduct.976199-2") }}</el-button
						>
						<el-button
							style="margin-left: 10px"
							type="success"
							round
							size="mini"
							v-else
							@click="isExpand = false"
							>{{ $t("product.AddProduct.976199-3") }}</el-button
						>
					</el-row>
					<template v-if="isExpand">
						<el-row :gutter="20">
							<el-col :span="8" v-if="fromMaterial !== '1'">
								<el-form-item :label="$t('addProduct.tag')" prop="goodsTags">
									<el-select
										v-model="product.goodsTags"
										multiple
										collapse-tags
										:placeholder="$t('common.select')">
										<el-option
											v-for="item in productTags"
											:key="item.id"
											:label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						<el-col :span="8">
							<el-form-item :label="$t('addProduct.code')" prop="no">
								<el-input
									v-model="product.no"
									:placeholder="$t('addProduct.pCode')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item :label="$t('addProduct.goodsBarcode')" prop="goodsBarcode">
								<el-input
									v-model="product.goodsBarcode"
									:placeholder="$t('addProduct.pGoodsBarcode')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addProduct.describe')" prop="content">
									<el-input
										v-model="product.content"
										type="textarea"
										:rows="4"
										:placeholder="$t('addProduct.pDescribe')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item
									:label="$t('addProduct.introduction')"
									prop="introduction">
									<el-tiptap
										@onInit="onInit"
										@onUpdate="onUpdate"
										v-model="product.introduction"
										maxlength="5"
										:extensions="extensions"
										:lang="
										this.$i18n.locale === 'zh_CN'
												? 'zh'
											: this.$i18n.locale === 'en_US'
												? 'en'
												: 'en'
										"
										:size="3" />
									<div
										class="el-upload__tip"
										style="color: red; margin-top: 15px; text-align: right;">
										{{ $t("addProduct.chaoguo") }}
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</template>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('product')"
					>{{
						fromMaterial === "1"
							? $t("product.AddProduct.537115-0")
							: $t("common.definite")
					}}</el-button
				>
			</div>
		</el-dialog>
			<add-product-type
				v-on:cancel="cancelCreate"
				:productType="productType"
				:dialogProductType="dialogProductType">
			</add-product-type>
		</div>
	</template>

<script>
import { mapGetters } from "vuex";
import config from "@/http/config";
import addProductType from "_c/product/AddProductType";
import {
	// 需要的 extensions
	Doc,
	Text,
	Paragraph,
	Heading,
	Bold,
	Underline,
	Italic,
	Strike,
	ListItem,
	BulletList,
	OrderedList,
	Link,
	Image,
	CodeBlock,
	Blockquote,
	TodoItem,
	TodoList,
	TextAlign,
	FontSize,
	FontType,
	Fullscreen,
	TextHighlight,
	TextColor,
	FormatClear,
	Table,
	TableHeader,
	TableCell,
	TableRow,
	History,
	TrailingNode,
	HardBreak,
	HorizontalRule,
	LineHeight,
	Indent,
} from "element-tiptap";
export default {
	name: "AddProduct",
	components: {
		addProductType,
	},
	props: {
		product: Object,
		dialogProduct: Boolean,
		productTags: Array,
			fromMaterial: {
				type: String,
				default: "0",
			},
		},
	data() {
		return {
			isExpand: false,
			productType: {},
			dialogProductType: false,
			labelPosition: "top",
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addProduct.pProductName"),
						trigger: "blur",
					},
				],
				costPrice: [
					{
						required: true,
						message: this.$t("addProduct.pPrice"),
						trigger: "blur",
					},
					{
						pattern: /^\d+(\.\d{0,2})?$/,
						message: this.$t("addProduct.rPrice"),
					},
				],
				url: [
					{
						required: true,
						message: this.$t("addProduct.pImage"),
						trigger: "change",
					},
				],
			},
			machineType: [],
			fileList: [],
			clear: false,
			uploadUrl: config.baseUrl + "upload/goods",
			sdUploadUrl: config.baseUrl + "upload/sdfile",
				loadingForm: false,
				extensions: this.getExtensions(),
				length: 0,
				imageUploading: false,
		};
		},
	computed: {
		...mapGetters(["token"]),
		uploadHeaders() {
			return {
				token: this.token,
			};
		},
	},
	methods: {
		getExtensions() {
			let that = this;
			return [
				new Doc(), // 必须项
				new Text({
					length: 20,
				}), // 必须项
				new Paragraph(), // 必须项
				new Heading({ level: 6 }), // 标题
				new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
				new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
				new Italic({ bubble: true }), // 斜体
				new Strike({ bubble: true }), // 删除线
				new ListItem(), // 使用列表必须项
				new BulletList({ bubble: true }), // 无序列表
				new OrderedList({ bubble: true }), // 有序列表
				new Link(), // 链接
				new Image({
					// 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
					// 自定义图片上传(默认会把图片生成base64字符串和内容存储到一起)
					// 图片的上传方法，返回一个 Promise<url>
					async uploadRequest(file) {
						// 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
						const formdata = new FormData();
						//  image是后台接口需要参数名
						formdata.append("file", file);
						//  调用接口进行上传,拿到服务器返回的图片地址
						const res = await that.$api.request(
							that.$url.common.upload,
							that.$method.post,
							formdata
						);

						if (res.code === 0) {
							return res.data;
						}
						that.$message.warning(res.msg);
						return false;
					},
				}), // 图片
				new CodeBlock({ bubble: true }), // 代码块
				new Blockquote(), // 引用
				new TodoItem(), // 任务列表必须项
				new TodoList(), // 任务列表
				new TextAlign({ bubble: true }), // 文本对齐方式
				new FontSize({ bubble: true }), // 字号
				new FontType({ bubble: true }), // 字体
				new Fullscreen(), // 全屏
				new TextHighlight({ bubble: true }), // 文本高亮
				new TextColor({ bubble: true }), // 文本颜色
				new FormatClear({ bubble: true }), // 清除格式
				new Table({ resizable: true }), // 表格
				new TableHeader(), // 表格必须项
				new TableCell(), // 表格必须项
				new TableRow(), // 表格必须项
				new History(), // 撤销
				new TrailingNode(), // 重做
				new HardBreak(), // 分割线
				new HorizontalRule(), // 行距
				new LineHeight(), // 增加缩进
				new Indent(), // 减少缩进
			];
		},
		handlerCreateProductType() {
			this.dialogProductType = true;
		},
		cancelCreate() {
			this.dialogProductType = false;
			this.getProductType();
		},
		onInit({ editor }) {
		},
		onUpdate(editor) {
			var content = editor.replace(/<.*?>/g, "");
			this.length = content.length;
		},
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		submitForm(formName) {
			if (this.length > 5000) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("addProduct.chaoguo"),
					type: "error",
				});
				return false;
			}
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.Product.insert;
					let method = this.$method.post;
					if (this.product.id) {
						url = this.$url.Product.update;
						method = this.$method.put;
					}
					// 添加素材库商品
					if (this.fromMaterial === "1") {
						url = this.$url.ProductLibrary.insert;
						method = this.$method.post;
					}
					let arr = [];
					if (this.product.goodsTags) {
						this.product.goodsTags.forEach(key => {
							let obj = { goodsTagId: key };
							arr.push(obj);
						});
					}
					this.product.goodsTags = arr;
					this.$api
						.request(url, method, this.product)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.clear = true;
								this.cancel(this.product.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		closeDialog() {
			this.clearValidate("product");
			this.machineType = [];
			this.resetImageUploadState();
			if (this.product.id) {
				this.$toolUtil.clearForm(this.product);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.product);
				}
			}
			this.cancel("");
		},
		openDialog() {
			this.resetImageUploadState();
			this.syncImageUploadFiles();
			// 获取商品类型
			this.getProductType();
			let arr = [];
			if (this.product.goodsTags) {
				this.product.goodsTags.forEach(key => {
					arr.push(key.goodsTagId);
				});
				}
				this.product.goodsTags = arr;
			},
			getProductType() {
				this.$api
				.request(this.$url.ProductType.list, this.$method.get, {
					goodsId: this.product.id,
				})
				.then(res => {
					if (res.code === 0) {
						this.machineType = res.data;
					}
				});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		//  商品缩略图上传
		handleImageError(err) {
			this.imageUploading = false;
			this.$message.error(err.msg ? err.msg : this.$t("addProduct.error"));
			return false;
		},
		handleImageRemove() {
			this.product.url = "";
			this.fileList = [];
		},
		beforImageUpload(file) {
			const isJPGPNG = file.type === "image/jpeg" || file.type === "image/png";
			const isLt1M = file.size / 1024 / 1024 < 1;
			if (!isJPGPNG) {
				this.$message.error(this.$t("addProduct.imagexzgs"));
				return false;
			}
			if (!isLt1M) {
				this.$message.error(this.$t("addProduct.imagexzdx"));
				return false;
			}
			this.imageUploading = true;
			return true;
		},
		handleImageSuccess(res) {
			this.imageUploading = false;
			if (res.code === 0) {
				this.product.url = res.data;
				this.syncImageUploadFiles();
				if (this.$refs.product) {
					this.$refs.product.clearValidate("url");
				}
			} else {
				this.$message.warning(res.msg);
			}
		},
		handleImageExceed() {
			this.$message.warning(this.$t("addProduct.pImage"));
		},
		syncImageUploadFiles() {
			this.fileList = this.product.url
				? [{ name: "product_image", url: this.product.url }]
				: [];
		},
			resetImageUploadState() {
				this.imageUploading = false;
				this.fileList = [];
				if (this.$refs.productImageUpload) {
					this.$refs.productImageUpload.clearFiles();
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
.el-upload-list--picture-card .el-upload-list__item {
	margin: 0;
}
.upload-wrapper {
	position: relative;
	display: inline-block;
}
.uploaded-image {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.uploaded-image img {
	width: 90%;
	height: 90%;
	object-fit: contain;
}
.upload-loading {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
}
.upload-loading i {
	font-size: 24px;
	color: #409eff;
}
.quill-editor editor {
	height: 600px !important;
}
.ql-container ql-snow {
	height: 480px !important;
}
.addproductclass .el-dialog__header {
	padding: 20px;
}
.addproductclass .el-dialog__body {
	padding: 0 20px 10px 20px !important;
	margin: 0 !important;
	height: auto;
}
.addproductclass .el-dialog__footer {
	padding: 0 20px 20px 20px;
}
.addproductclass .el-form--label-top .el-form-item__label {
	padding-bottom: 0;
}
.addproductclass .el-form-item {
	margin-bottom: 15px;
}
.title_header {
	line-height: 24px;
	font-size: 18px;
	color: #303133;
	display: flex;
	align-items: center;
}
.search {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
}
::v-deep .el-dialog__body {
	height: auto;
}
</style>
